import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import Header from "./Header";
import Footer from "./Footer";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
  <Header style={{marginBottom:"20px"}}/>
    <App />
    <Footer/>
  </React.StrictMode>
);
